import { CouplePatientAPI, GroupPatientAPI, type GroupPatient, listAllTherapistPatientsResponse } from "../../patient";

/**
 * The therapist's caseload a board can be opened for: their individual
 * patients (first 100), couples and groups. A failing group list counts as no
 * groups; any other failure rejects.
 */
export async function loadConstellationCaseload(therapistId: string) {
    const [individualRes, coupleRes, groupRes] = await Promise.all([
        listAllTherapistPatientsResponse(therapistId),
        CouplePatientAPI.listByTherapist(therapistId),
        GroupPatientAPI.list().catch(() => ({ data: [] as GroupPatient[] })),
    ]);
    return { patients: individualRes.data.patients, couples: coupleRes.data, groups: groupRes.data };
}
